module.exports = __webpack_public_path__ + "img/co5.33b5e6c3.png";